import columns from './utils/columns'
import summaries from './utils/summaries'

const state = () => ({
  deliveryRoutes: ['delivery', 'pacing', 'discrepancy'],

  reportId: null,
  reportName: null,
  reportPath: null,
  subId: null,

  publisher: null,
  team: null,

  publishers: [],
  teams: {},

  columns,
  summaries,
  currentRecord: {},

  discrepancyLineItems: [],
  lineItems: [],
  orders: [],

  lineItemHistory: [],
  discrepancyCreatives: [],

  creatives: [], // @TODO: [PLAN-416] Rename creatives to pacingCreatives
  creativesReport: {},
  tearsheets: {},

  isLegendModalVisible: false,
  isDiscrepancyCreativeModalVisible: false,
  isLoadingDiscrepancyCreatives: false,
  didLoadDiscrepancyCreativesFail: false,

  isLineItemHistoryModalVisible: false,
  isLoadingLineItemHistory: false,
  didLoadLineItemHistoryFail: false,

  isCreativeModalVisible: false,
  isLoadingLineItemCreative: false,
  didLoadLineItemCreativeFail: false,

  isCreativesReportModalVisible: false,
  isLoadingCreativesReport: false,
  didLoadCreativesReportFail: false,
})

export default state
